import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Link } from 'react-router-dom';

import LogoIcon from '../../../assets/icons/logo.svg';
import { fadeIn } from '../../common/data/animations';

export const MediaWrapper = styled.div<{isScrolling?: boolean; isLoading?: boolean}>`
    position: relative;
    display: flex;
    align-items: center;
    min-width: 90px;
    justify-content: center;
    ${({isScrolling, isLoading}) => !isScrolling && !isLoading && css`
      border-right: 1px solid #F0F0F0;
    `};
    z-index: 2;

    input[hidden] {
        display: none;
    }
`;

export const Logo = styled.img`
    width: 32px;
    height: 32px;
`;

Logo.defaultProps = {
    src: LogoIcon,
};

const commonLogoWrapperStyles = ({ show }: { show?: number }) => css`
    position: relative;
    flex: none;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    transition: all 0.4s ease;
    overflow: hidden;
    z-index: 2;
    &:before {
        content: '';
        position: absolute;
        top: 50%;
        right: 0;
        width: 1px;
        height: 42px;
        background-color: #D9D9D9;
        transform: translateY(-50%);
        transition: background-color 0.4s ease;
    }

    ${show ? css`
        width: clamp(50px, 6vw, 90px);
        opacity: 1;
        visibility: visible;
    ` : css`
        width: 0;
        opacity: 0;
        visibility: hidden;
    `}

    &:hover {
        background-color: #efefef;

        &:before {
            background-color: #efefef;
        }
    }
`;

export const LogoWrapper = styled.a<{ show?: number }>`
    ${(props) => commonLogoWrapperStyles(props)};
`;

export const LinkedLogoWrapper = styled(Link)<{ show?: number }>`
    ${(props) => commonLogoWrapperStyles(props)};
`;

export const HeaderWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 980px;
`;


export const InfoWrapper = styled.div<{ isDisableEditing?: boolean }>`
    height: 100%;
    display: flex;
    justify-content: center;
    transition: all 0.4s ease;

    ${({ isDisableEditing }) => isDisableEditing && css`
        & > *:not(:first-child) {
            opacity: 0.4;
            pointer-events: none;
            will-change: transform;
        }
    `};
`;

export const List = styled.ul`
    display: flex;
    align-items: center;
    list-style: none;
    padding: 0 28px 0 0;
    margin: 0;
    z-index: 0;
`;

export const BreadcrumbsWrapper = styled.div<{ isLoading?: boolean; isScrolling: boolean }>`
    position: fixed;
    top: 78px;
    left: 0;
    width: 100%;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    box-sizing: border-box !important;
    transition: all 0.4s ease;
    animation: ${fadeIn} 0.6s ease;
    z-index: 89;
    border-bottom: 1px solid #F0F0F0;
    &:before {
        content: '';
        position: absolute;
        left: 0;
        bottom: 100%;
        width: 100%;
        height: 0;
        transition: all 0.2s ease;
    }

    ${({ isLoading }) => isLoading && css`
        ${List} li {
            animation-duration: 0 !important;
        }
    `}

    ${({ isScrolling }) => isScrolling && css`
        transition-duration: 0.2s;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
        transform: translateY(-78px);
        z-index: 91;

        &:before {
            height: 78px;
            background-color: #fff;
        }
    `}
`;
